import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";

/**
 * holds the components to show up the 'library asset select' window, having controls for listing and filtering assets
 */
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import Modal from "../../core/modal";
import LibrarySelect from "./library-select";
import { orderTypes } from "../../../enums";
/**
 * asset selector component, displaying filter controls and list of assets in a Modal window
 */

var LibrarySelectModal = createComponent({
  displayName: 'LibrarySelectModal',
  propTypes: {
    trigger: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    libraryRef: PropTypes.string,
    containerRef: PropTypes.string,
    onAssetSelected: PropTypes.func.isRequired,
    sort: PropTypes.string,
    order: PropTypes.oneOf(orderTypes.ALL)
  },
  defaultProps: {
    libraryRef: '',
    containerRef: '',
    sort: undefined,
    order: undefined
  },
  render: function render(props) {
    var trigger = props.trigger,
        librarySelectProps = _objectWithoutPropertiesLoose(props, ["trigger"]);

    return /*#__PURE__*/React.createElement(Modal, {
      trigger: trigger,
      hasCloseIcon: true,
      isSolid: true,
      isInverted: false,
      isFullscreen: false,
      className: "library-select-modal"
    }, /*#__PURE__*/React.createElement(LibrarySelect, _extends({}, librarySelectProps, {
      isInModal: true
    })));
  }
});
export default LibrarySelectModal;
//# sourceMappingURL=library-select-modal.js.map